import { takeLatest } from 'redux-saga/effects'
import { CREATE_USER_SAGA } from 'src/store/types/adminData'
import createUser from './createUser'

export function* createUserSaga() {
  yield takeLatest(CREATE_USER_SAGA, createUser)
}
